import type { SVGProps } from 'react';

export function DeviceLedgerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.435 13.778a1 1 0 0 1 0 1.414l-4.243 4.244a1 1 0 0 1-1.414 0L14 16.656V6q0-.36-.05-.706zM9 2a4 4 0 0 1 4 4v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a4 4 0 0 1 4-4m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
    </svg>
  );
}
